import { useContext } from "react";
import AuthContext from "../../../store/auth-context";
import { FaUserCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const DashInfo = (props) => {
  const { t } = useTranslation();
  const authCtx = useContext(AuthContext);
  const formattedDate = new Date().toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const { total, waiting } = props.stats || { total: 0, waiting: 0 };

  return (
    <div className="container mt-3 mb-0">
      <div className="welcome-banner">
        <div className="welcome-left">
          <h2>{props.title || "Dr. Teh Buddy"}</h2>
          <p>
            <i className="fa fa-stethoscope me-2" style={{ color: 'var(--primary-color)' }}></i>
            {t("What's happening today:")} {t("You have")} <span className="stats-summary">{total} {t("Appointments")}</span> {t("scheduled and")} <span className="stats-summary">{waiting} {t("Patients")}</span> {t("waiting in the queue.")}
          </p>
        </div>
        <div className="welcome-right">
          <div className="date-box mb-2" style={{ color: 'var(--primary-color)', fontWeight: '600' }}>
            <i className="fa fa-calendar me-2" style={{ color: 'var(--primary-color)' }}></i> {formattedDate}
          </div>
          <div className="user-name">
            <FaUserCircle className="text-secondary" style={{ fontSize: '1rem' }} />
            <span className="ms-1">{t("Welcome")}, </span>
            <span className="fw-bold ms-1" style={{ color: 'var(--primary-color)' }}>{authCtx.userName || "Admin"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashInfo;
